<div class="sequence-container">
  <div class="sequence-header">
    <h4 class="sequence-step-description"></h4>
  </div>
  <div class="sequence-step"></div>
  <div class="sequence-controls">
    <button class="sequence-prev btn btn--tertiary-blue">
      <span class="spinner"></span>
      Back
    </button>
    <button class="sequence-next btn btn--primary-red">
      <span class="spinner"></span>
      Next
    </button>
    <button class="sequence-submit btn btn--primary-red">
      <span class="spinner"></span>
      Submit
    </button>
    <button class="sequence-help btn btn--primary-red">
      <a class="text-link" href="https://support.starry.com">Get Help</a>
    </button>
  </div>
  <div class="sequence-step-footer"></div>
</div>
